import { render, staticRenderFns } from "./TixstockMobileHeader.vue?vue&type=template&id=78fc99f2&scoped=true"
import script from "./TixstockMobileHeader.vue?vue&type=script&lang=js"
export * from "./TixstockMobileHeader.vue?vue&type=script&lang=js"
import style0 from "./TixstockMobileHeader.vue?vue&type=style&index=0&id=78fc99f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc99f2",
  null
  
)

export default component.exports